import { Component } from '@angular/core';
import { NGXLogger } from "ngx-logger";
import { initLogger } from './common/services/logging/logging.service';

import { ApplicationService } from './common/services/application/application.service';
import { MEErrorService } from './common/error/me-error.service';
import { PlatformService } from './system/utility/platform.service';
import { DeviceSecurityService } from './system/utility/device-security.service';
import { SplashScreenService } from './system/utility/splash-screen.service';
import { AppService } from './system/utility/app.service';
import { VersionService } from 'src/app/system/utility/version.service';
import { ExternalSettingsService } from './common/services/external-settings/external-settings.service';
import { UIUtilityService } from './system/utility/ui-utility.service';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { LoadingService } from './common/services/loading/loading.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    standalone: false
})
export class AppComponent {

  protected UIUtilityService: any = UIUtilityService;
  protected PlatformService: any = PlatformService;
  protected ExternalSettingsService: any = ExternalSettingsService;

  constructor(
    logger: NGXLogger,
    public srvError: MEErrorService,
    private srvApplication: ApplicationService,
    private srvSplashScreen: SplashScreenService,
    private srvDeviceSecurity: DeviceSecurityService,
    private srvApp: AppService,
    private srvVersion: VersionService,
    private router: Router,
    private loader: LoadingService
  ) {

    // Initialize logger
    initLogger(logger);

    // Initialize Splash Screen Service
    this.srvSplashScreen.init();

    // Device Security Check
    this.srvDeviceSecurity.isDeviceSecure().subscribe((isDeviceSecure) => {

      // If not secured, mark the application as initialized and return
      if (!isDeviceSecure) {
        this.srvApp.markInit(isDeviceSecure);
        return;
      };

      // Initialize the Service that External Settings depends on 
      this.srvApp.init();

      // Initialize Version Check Service
      this.srvVersion.init().subscribe((isVersionOkay: boolean) => {
        if (!isVersionOkay) {
          return;
        }

        // Initialize Service that depends on External Settings
        this.srvApplication.init();
      });
    });

    router.events.subscribe(event => {
      if (event instanceof NavigationStart) loader.navStart();
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        loader.navEnd();
      }
      
      if (event instanceof NavigationCancel) {
        logger.debug('Navigation Cancelled:', event.reason, event.url);
      }
      if (event instanceof NavigationError) {
        logger.error('Navigation Error:', event.error, event.url);
      }
    });

  }

}